export default __webpack_public_path__ + "static/media/optimization.60880975.svg";